// MasterComponent.tsx — master page, plug in new masters via MASTER_CONFIGS only
import "rsuite/DatePicker/styles/index.css";
import { useEffect, useState } from "react";
import { LargeDataMasterRoute } from "~/pages/all-routes";
import { toast } from "react-toastify";
import MastersTable from "./masterTable";
import { MASTER_CONFIGS } from "./masterConfigs";
import type { ReportFetchParams } from "./masterConfigs";

const DEFAULT_ROWS_PER_PAGE = 10;

const MasterComponent = () => {
  const { master_name } = LargeDataMasterRoute.useSearch();
  const [data, setData] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const config = MASTER_CONFIGS[master_name];

  const fetchData = async (params?: ReportFetchParams) => { 
    if (!config) return;

    const requestParams: ReportFetchParams = params ?? {
      searchstring: "",
      orderbycol: config.columns[0]?.key || "id",
      orderdirection: "ASC",
      startrowindex: 1,
      maximumrows: DEFAULT_ROWS_PER_PAGE,
      gettotal: true,
    };

    setIsLoading(true);
    try {
      const { data: res, status } = await config.fetchFn(requestParams);
      if (status && res) {
        const rows = (res as any)?.data?.customers ?? (res as any)?.data ?? res;
        setData(Array.isArray(rows) ? rows : []);

        //const total = (res as any)?.data?.total ?? (res as any)?.total;

        const total = (res as any)?.data?.total?.[0]?.count || 0;
        if (requestParams.gettotal && typeof total === "number") {
          setTotalRecords(total);
        } else if (!requestParams.gettotal) {
          // count wasn't requested this time, keep previous totalRecords
        } else {
          setTotalRecords(Array.isArray(rows) ? rows.length : 0);
        }
      } else {
        toast.error("Failed to load data", { theme: "colored" });
      }
    } catch {
      toast.error("Failed to load data", { theme: "colored" });
    } finally {
      setIsLoading(false);
    }
  };

  const deleteRows = async (ids: string[]) => {
    if (!config?.deleteFn) return { status: false };
    const res = await config.deleteFn(ids);
    return res;
  };

  // Reset + refetch on master switch
  useEffect(() => {
    setData([]);
    setTotalRecords(0);
    void fetchData();
  }, [master_name]);

  if (!config) {
    return <div className="p-4 text-red-500">Unknown master: "{master_name}"</div>;
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h4 className="text-2xl font-semibold text-orange-500">{config.title}</h4>
      </div>

      <div className="bg-neutral-100 rounded-lg p-3">
        <MastersTable
          key={master_name}
          config={config}
          data={data}
          totalRecords={totalRecords}
          onDataUpdate={setData}
          fetchData={fetchData}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};
export default MasterComponent;
